import { watch } from 'vue'

import { useProfileStore } from './store'

export const useOnTimezoneChange = (callback: () => void): void => {
  const profileStore = useProfileStore()

  watch(
    () => profileStore.getTimezone,
    () => callback(),
  )
}
